import axios, { AxiosInterceptorManager, AxiosRequestConfig } from "axios";
import { baseURL } from "./Utils/environment";

const axiosInstance = axios.create({
    baseURL,
    headers: {
        'Content-Type': 'application/json',
    },
});

if (import.meta.env.MODE === "development") {
    localStorage.removeItem("jwt_token");
    localStorage.removeItem("jwt_token_expires_at");

    const fetchToken = async (): Promise<string> => {
        const response = await axios.post(
            `${baseURL}/api/dev/connect`,
            {
                username: import.meta.env.VITE_USERNAME,
                password: import.meta.env.VITE_PASSWORD,
                clientId: import.meta.env.VITE_CLIENT_ID,
                clientSecret: import.meta.env.VITE_CLIENT_SECRET,
                scope: import.meta.env.VITE_SCOPE,
            }
        );

        const { accessToken: token, expiresIn: expiresInSeconds } = response.data;

        const now = new Date();
        const expiresAt = new Date(now.getTime() + (expiresInSeconds - 60) * 1000);

        localStorage.setItem("jwt_token", token);
        localStorage.setItem("jwt_token_expires_at", expiresAt.toISOString());

        return token;
    };

    const getToken = (): string | null => {
        const token = localStorage.getItem("jwt_token");
        const expiresAt = localStorage.getItem("jwt_token_expires_at");
        const expiresAtDate = new Date(expiresAt || "");
        if (!token || !expiresAt || expiresAtDate < new Date()) {
            return null;
        }
        return token;
    }

    const onRequestFulfilled = async (config: AxiosRequestConfig) => {
        let token = getToken();

        if (!token) {
            token = await fetchToken();
        }

        if (config.headers) {
            config.headers['Authorization'] = `Bearer ${token}`;
        }

        return config;
    };

    const onRequestRejected = (error: any) => Promise.reject(error);

    (axiosInstance.interceptors.request as AxiosInterceptorManager<AxiosRequestConfig>)
        .use(onRequestFulfilled, onRequestRejected);
}

function logout() {
    const form = document.createElement("form");
    form.method = "POST";
    form.action = "/api/user/logout";
    document.body.appendChild(form);
    form.submit();
}

axiosInstance.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response.status === 401) {
            logout();
            return;
        }
        return Promise.reject(error);
    }
);

export default axiosInstance;
